/*************************************************/
/* CUSTOM CURSOR                                 */
/*************************************************/

export function customCursor() {
    const componentSelector = ".cursor";
    const customCursorUrl = "/assets/images/custom_cursor.svg";
    const customCursorClass = "customCursor";
    const customCursorWidth = 65;
    const customCursorHeight = 65;
    let moveTimer = false;
    const rotatorCursorUrl = "/assets/images/Cursor-Icon-01.svg";
    const rotatorCursorClass = "rotator-cursor";

    const getCursorPosition = function (event, element) {
        return {
            x: event.clientX - element.left - customCursorWidth / 2,
            y: event.clientY - element.top - customCursorHeight / 2
        };
    }

    const updateCursorPosition = function (event) {
        const navigationBoxRect = event.target.closest(componentSelector).getBoundingClientRect();
        const mousePosition = getCursorPosition(event, navigationBoxRect);
        const customCursorElement = event.target.closest(componentSelector).querySelector("." + customCursorClass);
    
        if (customCursorElement != null) {
            customCursorElement.style.top = mousePosition.y + "px";
            customCursorElement.style.left = mousePosition.x + "px";
            customCursorElement.style.display = "block";
        }
    };

    const init = function () {
        document.querySelectorAll(componentSelector).forEach(box => {
            box.addEventListener("mousemove", e => {
                const _event = e;
                if (_event.target.closest(componentSelector).querySelector("." + customCursorClass) == null) {
                    const customCursor = document.createElement("img");
                    customCursor.classList.add(customCursorClass);
                    if (box.classList.contains(rotatorCursorClass)) {
                        customCursor.src = rotatorCursorUrl; 
                    } else {
                        customCursor.src = customCursorUrl;
                    }

                    const mousePosition = getCursorPosition(_event, box);
                    customCursor.height = customCursorHeight;
                    customCursor.width = customCursorWidth;
                    customCursor.style.display = "none";
                    customCursor.style.position = "absolute";
                    customCursor.style.zIndex = 999;
                    customCursor.style.pointerEvents = "none";
                    customCursor.style.top = mousePosition.y + "px";
                    customCursor.style.left = mousePosition.x + "px";
                    _event.target.closest(componentSelector).appendChild(customCursor);
                }
                moveTimer = setTimeout(() => {
                    updateCursorPosition(_event);
                }, 1);
            });

            box.addEventListener("mouseleave", (e) => {
                e.target.closest(componentSelector).querySelector("." + customCursorClass).remove();
                moveTimer = false;
            });
        });
    };

    init();
}